/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_BranchInputs */

const en_case_field_branch = /** @type {(inputs: Case_Field_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch`)
};

const pt_br2_case_field_branch = /** @type {(inputs: Case_Field_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filial`)
};

/**
* | output |
* | --- |
* | "Branch" |
*
* @param {Case_Field_BranchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_branch = /** @type {((inputs?: Case_Field_BranchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_BranchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_branch(inputs)
	return pt_br2_case_field_branch(inputs)
});